var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"interdict",class:`hook-${_vm.hook} layout-${_vm.layout}`},[_c('div',{staticClass:"empty-box"},[_c('div',{staticClass:"icon"}),(!_vm.loading)?_c('p',[_vm._v(_vm._s(_vm.tip))]):_c('p',[_vm._v(_vm._s(_vm.loadingTip))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }